<template lang="pug">
v-layout
  v-flex
    v-text-field(
      label='Название',
      v-model='block.value.name',
      @input='$emit("update", block)'
    )
  v-flex
    v-text-field(
      label='URL',
      v-model='block.value.url',
      @input='$emit("update", block)'
    )
</template>

<script>
import BaseBlock from './BaseBlock'
import PropTypes from '@znck/prop-types'
export default {
  extends: BaseBlock,
  props: {
    block: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    }),
  },
}
</script>
